import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { ReportTypeEnum } from "../../../../../constants/constants";
import { DATA_TABLE_UTIL } from "../../../../../utils/data-table.utils";
import "./output-table.scss";


interface Props {
    data?: any[];
    loading?: boolean;
    type?: ReportTypeEnum;
    columns?: any[];
    table_code?: string;
}

const OutPutTable = (props: Props) => {

    const [columns, setColumns] = useState<any[]>();

    useEffect(() => {
        if (props.data) {
            setColumns(DATA_TABLE_UTIL.getColumnsTableData(props.data, props.type, props.columns, props.table_code));
        }
    }, [props.data, props.type, props.columns, props.table_code])

    return (
        <div className={`ecap-table-output-wrapper${props.type === ReportTypeEnum.CreditRisk ||
            props.type === ReportTypeEnum.ConcentrationRisk ||
            props.type === ReportTypeEnum.Ramp ||
            props.type === ReportTypeEnum.BusinessRisk ? "" : " no-total"}`}>
            <Table
                loading={props.loading}
                dataSource={props.data}
                bordered={true}
                columns={columns} pagination={false} scroll={{ x: true }} />
        </div>
    )
}

export default OutPutTable;